/*
    Copyright (C) 2023 - LMS2MTX - Southwest Airlines
*/
export const ACCESS_TOKEN_KEY = "access_token";
export const USER_ID = "user_id";
export const AUTHORIZATION_OUTSTANDING_KEY = "authorization_outstanding";
